/* eslint-disable no-unused-vars */
import { useState } from 'react';
import { CaptionText, H4, P1, P2, P3 } from '../../styles/FontStyles';
import { Box, Button, Flexed } from '../../styles/GlobalComponents';
import { color } from '../../styles/GlobalStyles';
import { BoxBig, HubImage, Td, Tr } from '../Portfolio/Portfolio.styled';

import moment from 'moment';
import { formatUSDNoDecimals } from '../../helpers/helperFunctions';
import { Responsive } from '../../styles/stylesStyled';
import { useTranslation } from 'react-i18next';
import Spinner from '../../components/common/Spinner';
import { WebinarTicket } from '../../slices/webinars-slice';

import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }

  50% {
    transform: scale(1.4);
    opacity: 0.5;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

const UpcomingDot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #87d6ce;
`;

const LiveDot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #5cc5ec;
  animation: ${pulse} 1.2s infinite;
`;

const CompletedDot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #2b3896;
`;

export const TicketItem = ({ item }: { item: WebinarTicket }) => {
  const isJoinButtonEnabled = () => {
    const now = new Date();

    const startTime = new Date(item.dateStart);

    const enableTime = new Date(startTime.getTime() - 15 * 60 * 1000);
    const endTime = new Date(startTime.getTime() + 45 * 60 * 1000);

    return now >= enableTime && now <= endTime;
  };

  const getWebinarStatus = (
    webinar: WebinarTicket
  ): 'upcoming' | 'live' | 'completed' => {
    const now = moment();

    const startTime = moment(webinar.dateStart);
    const endTime = moment(webinar.dateStart).add(45, 'minutes');

    if (now.isBefore(startTime)) {
      return 'upcoming';
    }

    if (now.isSameOrBefore(endTime)) {
      return 'live';
    }

    return 'completed';
  };

  const status = getWebinarStatus(item);

  return (
    <>
      {' '}
      <Box>
        <div>
          <div>
            <div
              style={{
                position: 'absolute',
                left: '50%',
                right: '50%',
                transform: 'translate(-50%, -50%)'
              }}>
              <Spinner />
            </div>

            <P1 semiBold mb='40' color={color.colors.primary900}>
              DATE: {moment(item?.dateStart).format('DD MMM YYYY, h:mm A')}
            </P1>

            <Tr style={{ cursor: 'pointer' }}>
              <Td w='25%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  Webinar Name
                </CaptionText>
                <P1 bold flex alignEnd gap='5px'>
                  {item.webinarName}
                </P1>
              </Td>
              <Td w='25%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  Price
                </CaptionText>
                <P1 bold flex alignEnd gap='5px'>
                  {formatUSDNoDecimals(item.ticketPrice)} <P3 mb='3'>USDT</P3>
                </P1>
              </Td>

              <Td w='25%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  Date Of Purchase
                </CaptionText>
                <P1 bold>{moment(item?.datePaid).format('DD MMM YYYY')}</P1>
              </Td>

              <Td w='25%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  Ticket ID
                </CaptionText>
                <P1 bold>{item?.ticketId}</P1>
              </Td>
              <Td w='25%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  Webinar ID
                </CaptionText>
                <P1 bold>{item?.webinarId}</P1>
              </Td>
            </Tr>

            <Flexed between mt='50'>
              <a href={item?.zoomJoinUrl} target='_blank' rel='noreferrer'>
                <Button
                  w='200px'
                  maxWidthSM='100%'
                  disabled={!isJoinButtonEnabled()}>
                  JOIN WEBINAR
                </Button>
              </a>
              <>
                {' '}
                {status === 'upcoming' && (
                  <Flexed gap='8px' center mr='50'>
                    <UpcomingDot />
                    <P1 bold>Upcoming</P1>
                  </Flexed>
                )}
                {status === 'live' && (
                  <Flexed gap='8px' center mr='50'>
                    <LiveDot />
                    <P1 bold>Live</P1>
                  </Flexed>
                )}
                {status === 'completed' && (
                  <Flexed gap='8px' center mr='50'>
                    <CompletedDot />
                    <P1 bold>Completed</P1>
                  </Flexed>
                )}
              </>
            </Flexed>
          </div>
        </div>
      </Box>
    </>
  );
};
